import '../style/button-CzyirL3-.css'
import { defineComponent as g, useSlots as O, toRef as F, computed as o, withDirectives as K, openBlock as l, createElementBlock as c, normalizeClass as k, unref as r, normalizeStyle as N, withKeys as b, withModifiers as v, createBlock as _, normalizeProps as V, mergeProps as E, createCommentVNode as B, renderSlot as m } from "vue";
import L from "./icon.js";
import P from "./spinner.js";
import { BUTTON_ICON_SIZE as R } from "./constant/button.js";
import T from "./directives/ripple.js";
import { useButton as j } from "./hooks/useButton.js";
import { useFormItem as D } from "./hooks/useFormItem.js";
import { useInputSize as G } from "./hooks/useInputSize.js";
const M = ["type", "disabled", "aria-disabled", "onKeydown"], U = {
  key: 2,
  class: "e-button__loading-text"
}, Y = /* @__PURE__ */ g({
  name: "e-button",
  __name: "button",
  props: {
    colorScheme: { default: "primary" },
    size: {},
    outline: { type: Boolean },
    block: { type: Boolean },
    text: { type: Boolean },
    loading: { type: Boolean },
    disabled: { type: Boolean },
    padding: {},
    circle: { type: Boolean },
    ripple: { type: [Boolean, Object], default: !0 },
    type: { default: "button" },
    prefixIcon: {},
    suffixIcon: {},
    iconSpace: {},
    link: { type: Boolean },
    width: {},
    height: {}
  },
  emits: ["click"],
  setup(i, { emit: s }) {
    const t = i, { form: n, formSize: d } = D(), h = O(), { actualSize: f } = G({ formSize: d, propSize: F(t, "size") }), S = s;
    function z(e) {
      return e ? typeof e == "string" ? { icon: e, size: R[f.value] } : e : null;
    }
    const I = o(() => t.link ? "var(--text-active)" : "var(--common-white)"), w = o(() => t.link ? !1 : t.ripple), a = o(() => {
      const { prefixIcon: e, suffixIcon: y } = t;
      return z(e || y);
    }), C = o(() => a.value && !h.default), { buttonClassList: $, buttonStyle: x } = j({
      props: t,
      actualSize: f,
      isIconOnly: C
    }), p = o(() => t.disabled || t.loading);
    function u(e) {
      p.value || (S("click", e), n && (t.type === "reset" && n.resetFields?.(), t.type === "submit" && n.validateFields?.()));
    }
    return (e, y) => K((l(), c("button", {
      class: k(r($)),
      type: e.type,
      disabled: p.value,
      "aria-disabled": p.value,
      style: N(r(x)),
      onClick: u,
      onKeydown: [
        b(v(u, ["prevent"]), ["enter"]),
        b(v(u, ["prevent"]), ["space"])
      ]
    }, [
      a.value ? (l(), _(r(L), V(E({ key: 0 }, a.value)), null, 16)) : B("", !0),
      e.loading ? (l(), _(r(P), {
        key: 1,
        color: I.value
      }, null, 8, ["color"])) : B("", !0),
      e.loading ? (l(), c("span", U, [
        m(e.$slots, "default")
      ])) : m(e.$slots, "default", { key: 3 })
    ], 46, M)), [
      [r(T), w.value]
    ]);
  }
}), ee = /* @__PURE__ */ g({
  name: "e-button-group",
  __name: "button-group",
  props: {
    responsive: { type: Boolean },
    compact: { type: Boolean }
  },
  setup(i) {
    const s = i, t = o(() => [
      { "e-button-group--compact": s.compact },
      { "e-button-group--responsive": s.responsive }
    ]);
    return (n, d) => (l(), c("div", {
      class: k([t.value, "e-button-group"])
    }, [
      m(n.$slots, "default")
    ], 2));
  }
});
export {
  Y as Button,
  ee as ButtonGroup
};
//# sourceMappingURL=button.js.map
